jQuery(document).ready(function($) {

    var canvas_wrapper = $('#canvas-wrap'),
        canvas         = $('#canvas'),
        resolution     = window.devicePixelRatio || 1,
        suffix         = resolution == 2 ? '@2x.png' : '.png',
        mouse          = {x: 0, y: 0},
        rect           = canvas[0].getBoundingClientRect(),
        layers = [
        {
            url: '/wp-content/themes/tripnuts/assets/graphics/beach/1x/layer-01' + suffix,
            position: (323-40),
            distance: 98,
            texture: ''
        },
        {
            url: '/wp-content/themes/tripnuts/assets/graphics/beach/1x/layer-02' + suffix,
            position: (242-40),
            distance: 58,
            texture: ''
        },
        {
            url: '/wp-content/themes/tripnuts/assets/graphics/beach/1x/layer-03' + suffix,
            position: (303-40),
            distance: 48,
            texture: ''
        },
        {
            url: '/wp-content/themes/tripnuts/assets/graphics/beach/1x/layer-04' + suffix,
            position: (318-40),
            distance: 38,
            texture: ''
        },
        {
            url: '/wp-content/themes/tripnuts/assets/graphics/beach/1x/layer-05' + suffix,
            position: (333-40),
            distance: 18,
            texture: ''
        },
        {
            url: '/wp-content/themes/tripnuts/assets/graphics/beach/1x/layer-06' + suffix,
            position: (162-40),
            distance: 18,
            texture: ''
        },
        {
            url: '/wp-content/themes/tripnuts/assets/graphics/beach/1x/layer-07' + suffix,
            position: -(142-40),
            distance: 8,
            texture: ''
        }
        ];

    PIXI.utils.skipHello();
    App       = new PIXI.Application(2045, 865, {view: canvas[0], backgroundColor: 0xF8F4D4, resolution: resolution}),
    Container = new PIXI.Container();
    App.stage.addChild(Container);
    PIXI.loader
        .add(layers)
        .load(setup);

    $(window).on('debouncedresize', function(e) {
        setup();
    });

    function setup() {
        canvas_wrapper.off('mousemove', updateCanvas);
        Container.removeChildren();

        for (var i = (layers.length - 1); i >= 0; i--) {
            layers[i].texture   = new PIXI.Sprite(PIXI.loader.resources[layers[i].url].texture);
            layers[i].texture.y = layers[i].position;
            Container.addChild(layers[i].texture);
        }

        if ($('.screensize').is(':visible')) {
            canvas_wrapper.on('mousemove', updateCanvas);
        }
    }

    function updateCanvas() {
        mouse.y = (App.renderer.plugins.interaction.mouse.global.y - rect.top);
        for (var i = (layers.length - 1); i >= 0; i--) {
            TweenLite.to(layers[i].texture, .3, {y: (layers[i].position - (mouse.y * (layers[i].distance / rect.height))), ease: Power1.easeOut});
        }
    };
});